@if (capitalstructure.cashonhandCapitalStructure?.length) {
<h3>Cash on Hand: {{ capitalstructure.cashonhandCapitalStructure[0].instrument_amount | currency:
    capitalstructure.cashonhandCapitalStructure[0].instrument_amount_currency }} </h3>
}

@if (capitalstructure.dips?.length) {
<h3>DIPs</h3>
}

@if (capitalstructure.dips?.length) {
<table class="table pagetable">
    <thead>
        <tr>
            <th></th>
            <th>Instrument Name</th>
            <th>Type</th>
            <th>Sub-Type</th>
            <th>Security Priority</th>
            <th>Level of Security</th>
            <th>Maturity Date</th>
            <th class="text-center">Interest Rate</th>
            <th class="text-end">Issuance Principal Amount</th>
            <th class="text-center">DIP Status</th>
        </tr>
    </thead>
    <tbody>
        @for (instrument of capitalstructure.dips; track instrument; let i = $index) {

            <ng-template #currentDipLifecyclePoint [ngTemplateOutlet]="currentDipLifecyclePoint" let-current="aCurrent" [ngTemplateOutletContext]="{ aCurrent:  instrument['dip_' + instrument.dip_status.toLowerCase()]}">
                <tr class="clickable" (click)="isExpanded[instrument.instrument_id] = ! isExpanded[instrument.instrument_id]" [id]="instrument.instrument_id">
                    <td class="row-toggle"><i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[instrument.instrument_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs></td>
                    <td class="instrument-name">{{instrument.instrument_name}}</td>
                    <td>{{instrument.instrument_type}}</td>
                    <td>{{instrument.instrument_sub_type}}</td>
                    <td>{{instrument.instrument_priority}}</td>
                    <td>{{instrument.instrument_security}}</td>
                    <td>{{ current.instrument_maturity_date | date }}</td>
                    <td class="text-center"><interest-rates [rates]="current.interest_rates"></interest-rates></td>
                    <td class="text-end">
                        {{ current.instrument_amount | currency: current.instrument_amount_currency }}
                        <ng-container *ngTemplateOutlet="dipChangedInfo; context: {$implicit: instrument, field: 'instrument_amount', currency: current.instrument_amount_currency}"></ng-container>
                    </td>
                    @if (instrument.dip_withdrawn !== 'Yes') {
<td class="text-center">{{ instrument.dip_status }} </td>
}
                    @if (instrument.dip_withdrawn === 'Yes') {
<td class="text-center">Withdrawn</td>
}
                </tr>
                @if (expandAll || isExpanded[instrument.instrument_id]) {
<tr @expandCollapse>
                    <td colspan="20" class="pt-2 border-left border-right border-bottom rounded-bottom pb-2">
                        <app-instrument-view [instrument]="instrument" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" [expandAll]="expandAll"
                            class="collapsible" [canShowFactSetData]="true"></app-instrument-view>
                    </td>
                </tr>
}
            </ng-template>

}
    </tbody>
</table>
}
@if (capitalstructure.prepetitionCapitalStructure?.length) {

    @if (situationType === 'bankruptcy') {
    <h3>Pre-Petition Capital Structure</h3>
    } @else {
    <h3>Capital Structure</h3>
    }
    <prepost-capital-structure [structure]="capitalstructure.prepetitionCapitalStructure" [columns]="capitalstructure.prepetitionCapitalStructure_columns" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" [expandID]="expandIDString"></prepost-capital-structure>

}
@if (capitalstructure.postpetitionCapitalStructure?.length) {

    <h3>Post-Petition Capital Structure</h3>
    <prepost-capital-structure [structure]="capitalstructure.postpetitionCapitalStructure" [columns]="capitalstructure.postpetitionCapitalStructure_columns" [instrumentIDLookup]="instrumentIDLookup" [classesLookup]="classesLookup" [expandID]="expandIDString"></prepost-capital-structure>

}

@if (capitalstructure.tradedebtCapitalStructure && capitalstructure.tradedebtCapitalStructure.length) {

    <h3>General Unsecured Debt</h3>
    <table class="table">
        <thead>
            <tr>
                <th>Name</th>
                <th class="text-end">Amount</th>
                <th>Notes</th>
            </tr>
        </thead>
        <tbody>
            @for (debt of capitalstructure.tradedebtCapitalStructure; track debt; let i = $index) {

                <tr>
                    <td class="text-nowrap">
                        {{debt.instrument_name}}
                    </td>
                    <td class="text-end">
                        {{ debt.instrument_amount | currency: debt.instrument_amount_currency }}
                    </td>
                    <td [innerHTML]="debt.instrument_notes"></td>
                </tr>

}
        </tbody>
    </table>

}

<ng-template #dipChangedInfo let-dip let-field="field" let-currency="currency">
    @if ((dip.dip_status === 'Final' && (dip.dip_proposed[field] !== dip.dip_interim[field] || dip.dip_final[field] !== dip.dip_interim[field]))
                        || (dip.dip_status === 'Intermim' && (dip.dip_proposed[field] !== dip.dip_interim[field]))) {

        <ng-template #tipTemplate>
            <ul class="list-unstyled bg-white text-dark">
                <li>
                    <strong>Proposed</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_proposed[field], currency: currency}"></ng-container>
                </li>
                <li>
                    <strong>Interim</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_interim[field], currency: currency}"></ng-container>
                </li>
                @if (dip.dip_status === 'Final') {
<li>
                    <strong>Final</strong>: <ng-container *ngTemplateOutlet="addCurrency; context: {$implicit: dip.dip_final[field], currency: currency}"></ng-container>
                </li>
}
            </ul>
        </ng-template>
        <i-bs [name]="iconNames.InfoCircle" [ngbTooltip]="tipTemplate" containerClass="white-tooltip"></i-bs>

}
</ng-template>

<ng-template #addCurrency let-value let-currency="currency">
    @if (currency.length) {

        {{ value | currency: currency}}

}
    @if (!currency.length) {

        {{ value }}

}
</ng-template>
